import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/TaskDelete.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

const QuotesApprovedMailPopup = (props) => {
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  const [quotesEmail, setQuotesEmail] = useState("");
  const [validemail, setValidemail] = useState(false);

  useEffect(() => {
    props.setQuotesEmail(quotesEmail);
  }, [quotesEmail, props]);

  const checkEmailValidation = (e) => {
    // const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails = e.target.value;
    if (!emailPattern.test(emails) && emails.trim() !== "") {
      setValidemail(true);
    } else {
      setValidemail(false);
    }
  };

  return (
    <>
      <Modal
        id="asc"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="text-center">
          <div>
            <p className="firstHead pt- mb-0" style={{ color: "#333333" }}>
              {/* {fetchTransPlanBoadList[18]?.translation}{" "} */}
              You are going to send the quote for review and
            </p>
            <p className="firstHead m-0" style={{ color: "#333333" }}>
              {/* {fetchTransPlanBoadList[19]?.translation} */}
              signing to the client’s email:
            </p>

            <div
              className="firstHead mx-auto mt-4"
              style={{ color: "#333333", background: "#F1F1F1", width: "63%" }}
            >
              <input
                type="email"
                placeholder="Enter Client Email"
                value={quotesEmail}
                className="text-center w-100 p-2"
                style={{
                  color: "#333333",
                  border: "none",
                  background: "unset",
                }}
                onChange={(e) => {
                  setQuotesEmail(e.target.value);
                  checkEmailValidation(e);
                }}
              />
            </div>

            <div
              className={validemail ? "ps-1 py-2" : "invisible py-2"}
              style={{ color: "red", fontSize: "14px" }}
            >
              <i className="pe-1 bi bi-exclamation-circle"></i>
              Email is invalid
            </div>

            <p className="proceed pt-1">
              {/* {fetchTransPlanBoadList[20]?.translation} */}
              Do you want to continue?
            </p>
          </div>

          <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
            <div className="btnNoDiv">
              <button
                className="btnNo p-2"
                //  onClick={props.onHide}
                onClick={() => {
                  props.onHide();

                  if (window.location.pathname === "/quote-calculation") {
                    handleGeneralNotification({
                      notificationType: "CUSTOM",
                      text: `The quotes has changed the status to waiting.`,
                    });
                  }
                }}
              >
                {t("No")}
              </button>
            </div>

            <div
              className="btnYesDiv"
              style={{ background: "#00246A", border: "1px solid #00246A" }}
            >
              {/* <button onClick={props.handleDelete}>yes</button> */}
              <button
                className="btnYes p-2"
                disabled={validemail || quotesEmail === ""}
                //  onClick={props.handleDelete}
                onClick={() => {
                  props.handleDelete();

                  if (window.location.pathname === "/quote-calculation") {
                    handleGeneralNotification({
                      notificationType: "CUSTOM",
                      text: `The quotes has changed the status to waiting.`,
                    });
                  }
                }}
              >
                {/* {fetchTransPlanBoadList[22]?.translation} */}
                Send
                {props.loading === true && (
                  <div
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                  ></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* <Button variant="primary" onClick={handleShow}>
                Launch demo modal
            </Button>

            <Modal show={show} onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </>
  );
};

export default QuotesApprovedMailPopup;
